###
Util

Holds a bunch of methods for note math, conversions, some dom stuff.

Status: Active
###

{ floor, pow, random } := Math

// https://en.wikipedia.org/wiki/Circle_of_fifths
// Positive is number of sharps, negative is number of flats
// Maps staff position to scale pitch
// zero is C major / A minor
scale :=
  "-7": // Cb
    0: -1
    1: 1
    2: 3
    3: 4
    4: 6
    5: 8
    6: 10
  "-6": // Gb / eb
    0: -1
    1: 1
    2: 3
    3: 5
    4: 6
    5: 8
    6: 10
  "-5": // Db / bb
    0: 0
    1: 1
    2: 3
    3: 5
    4: 6
    5: 8
    6: 10
  "-4": // Ab / f
    0: 0
    1: 1
    2: 3
    3: 5
    4: 7
    5: 8
    6: 10
  "-3": // Eb / c
    0: 0
    1: 2
    2: 3
    3: 5
    4: 7
    5: 8
    6: 10
  "-2": // Bb / g
    0: 0
    1: 2
    2: 3
    3: 5
    4: 7
    5: 9
    6: 10
  "-1": // F / d
    0: 0
    1: 2
    2: 4
    3: 5
    4: 7
    5: 9
    6: 10
  0: // C / a
    0: 0
    1: 2
    2: 4
    3: 5
    4: 7
    5: 9
    6: 11
  1: // G / e
    0: 0
    1: 2
    2: 4
    3: 6
    4: 7
    5: 9
    6: 11
  2: // D / b
    0: 1
    1: 2
    2: 4
    3: 6
    4: 7
    5: 9
    6: 11
  3: // A / f#
    0: 1
    1: 2
    2: 4
    3: 6
    4: 8
    5: 9
    6: 11
  4: // E / c#
    0: 1
    1: 3
    2: 4
    3: 6
    4: 8
    5: 9
    6: 11
  5: // B / g#
    0: 1
    1: 3
    2: 4
    3: 6
    4: 8
    5: 10
    6: 11
  6: // F# / d#
    0: 1
    1: 3
    2: 5
    3: 6
    4: 8
    5: 10
    6: 11
  7: // C#
    0: 1
    1: 3
    2: 5
    3: 6
    4: 8
    5: 10
    6: 12

scaleAccidentals :=
  "-7":
    0: -1
    1: -1
    2: -1
    3: -1
    4: -1
    5: -1
    6: -1
  "-6":
    0: -1
    1: -1
    2: -1
    3: 0
    4: -1
    5: -1
    6: -1
  "-5":
    0: 0
    1: -1
    2: -1
    3: 0
    4: -1
    5: -1
    6: -1
  "-4":
    0: 0
    1: -1
    2: -1
    3: 0
    4: 0
    5: -1
    6: -1
  "-3":
    0: 0
    1: 0
    2: -1
    3: 0
    4: 0
    5: -1
    6: -1
  "-2":
    0: 0
    1: 0
    2: -1
    3: 0
    4: 0
    5: 0
    6: -1
  "-1":
    0: 0
    1: 0
    2: 0
    3: 0
    4: 0
    5: 0
    6: -1
  "0":
    0: 0
    1: 0
    2: 0
    3: 0
    4: 0
    5: 0
    6: 0
  "1":
    0: 0
    1: 0
    2: 0
    3: 1
    4: 0
    5: 0
    6: 0
  "2":
    0: 1
    1: 0
    2: 0
    3: 1
    4: 0
    5: 0
    6: 0
  "3":
    0: 1
    1: 0
    2: 0
    3: 1
    4: 1
    5: 0
    6: 0
  "4":
    0: 1
    1: 1
    2: 0
    3: 1
    4: 1
    5: 0
    6: 0
  "5":
    0: 1
    1: 1
    2: 0
    3: 1
    4: 1
    5: 1
    6: 0
  "6":
    0: 1
    1: 1
    2: 1
    3: 1
    4: 1
    5: 1
    6: 0
  "7":
    0: 1
    1: 1
    2: 1
    3: 1
    4: 1
    5: 1
    6: 1

scaleInv :=
  "-7": // Cb // TODO: not sure if this is correct
    0: [0, 1]
    1: [1, 0]
    2: [1, 1]
    3: [2, 0]
    4: [2, 1]
    5: [3, 1]
    6: [4, 0]
    7: [4, 1]
    8: [5, 0]
    9: [5, 1]
    10: [6, 0]
    11: [6, 1]
  "-6": // Gb / eb // TODO: not sure if this is correct
    0: [0, 1]
    1: [1, 0]
    2: [1, 1]
    3: [2, 0]
    4: [2, 1]
    5: [3, 0]
    6: [4, 0]
    7: [4, 1]
    8: [5, 0]
    9: [5, 1]
    10: [6, 0]
    11: [6, 1]
  "-5": // Db / bb
    0: [0, 0]
    1: [1, 0]
    2: [1, 1]
    3: [2, 0]
    4: [2, 1]
    5: [3, 0]
    6: [4, 0]
    7: [4, 1]
    8: [5, 0]
    9: [5, 1]
    10: [6, 0]
    11: [6, 1]
  "-4": // Ab / f
    0: [0, 0]
    1: [1, 0]
    2: [1, 1]
    3: [2, 0]
    4: [2, 1]
    5: [3, 0]
    6: [4, -1]
    7: [4, 0]
    8: [5, 0]
    9: [5, 1]
    10: [6, 0]
    11: [6, 1]
  "-3": // Eb / c
    0: [0, 0]
    1: [1, -1]
    2: [1, 0]
    3: [2, 0]
    4: [2, 1]
    5: [3, 0]
    6: [4, -1]
    7: [4, 0]
    8: [5, 0]
    9: [5, 1]
    10: [6, 0]
    11: [6, 1]
  "-2": // Bb / g
    0: [0, 0]
    1: [1, -1]
    2: [1, 0]
    3: [2, 0]
    4: [2, 1]
    5: [3, 0]
    6: [4, -1]
    7: [4, 0]
    8: [5, -1]
    9: [5, 0]
    10: [6, 0]
    11: [6, 1]
  "-1": // F / d
    0: [0, 0]
    1: [1, -1]
    2: [1, 0]
    3: [2, -1]
    4: [2, 0]
    5: [3, 0]
    6: [4, -1]
    7: [4, 0]
    8: [5, -1]
    9: [5, 0]
    10: [6, 0]
    11: [6, 1]
  0: // C / a
    // MIDI note % 12 -> [staffPosition, accidental]
    0: [0, 0]
    1: [0, 1]
    2: [1, 0]
    3: [1, 1]
    4: [2, 0]
    5: [3, 0]
    6: [3, 1]
    7: [4, 0]
    8: [4, 1]
    9: [5, 0]
    10: [5, 1]
    11: [6, 0]
  1: // G / e
    0: [0, 0]
    1: [0, 1]
    2: [1, 0]
    3: [1, 1]
    4: [2, 0]
    5: [3, -1]
    6: [3, 0]
    7: [4, 0]
    8: [4, 1]
    9: [5, 0]
    10: [5, 1]
    11: [6, 0]
  2: // D / b
    0: [0, -1]
    1: [0, 0]
    2: [1, 0]
    3: [1, 1]
    4: [2, 0]
    5: [3, -1]
    6: [3, 0]
    7: [4, 0]
    8: [4, 1]
    9: [5, 0]
    10: [5, 1]
    11: [6, 0]
  3: // A / f#
    0: [0, -1]
    1: [0, 0]
    2: [1, 0]
    3: [1, 1]
    4: [2, 0]
    5: [3, -1]
    6: [3, 0]
    7: [4, -1]
    8: [4, 0]
    9: [5, 0]
    10: [5, 1]
    11: [6, 0]
  4: // E / c#
    0: [0, -1]
    1: [0, 0]
    2: [1, -1]
    3: [1, 0]
    4: [2, 0]
    5: [3, -1]
    6: [3, 0]
    7: [4, -1]
    8: [4, 0]
    9: [5, 0]
    10: [5, 1]
    11: [6, 0]
  5: // B / g#
    0: [0, -1]
    1: [0, 0]
    2: [1, -1]
    3: [1, 0]
    4: [2, 0]
    5: [3, -1]
    6: [3, 0]
    7: [4, -1]
    8: [4, 0]
    9: [5, -1]
    10: [5, 0]
    11: [6, 0]
  6: // F# / d#
    0: [0, -1]
    1: [0, 0]
    2: [1, -1]
    3: [1, 0]
    4: [2, -1]
    5: [2, 0]
    6: [3, 0]
    7: [4, -1]
    8: [4, 0]
    9: [5, -1]
    10: [5, 0]
    11: [6, 0]
  7: // C#  // TODO: not entirely sure about this one
    0: [-1, -1]
    1: [0, 0]
    2: [1, -1]
    3: [1, 0]
    4: [2, -1]
    5: [2, 0]
    6: [3, 0]
    7: [4, -1]
    8: [4, 0]
    9: [5, -1]
    10: [5, 0]
    11: [6, -1]


invertScale := (s) ->
  Object.keys(s).reduce (m, key) ->
    value := s[key]
    m[value] = key|0
    return m
  , {}

inverseScales := Object.keys(scale).reduce (m, key) ->
  m[key] = invertScale(scale[key])
  return m
, {}

notes := "C C# D D# E F F# G G# A A# B".split(" ")

// Accidentals Enumeration
export Accidental :=
  Flat: {name: "flat", value: -1}
  Natural: {name: "natural", value: 0}
  Sharp: {name: "sharp", value: 1}
  None: {name: "none", value: undefined}

Accidental[-1] = Accidental.Flat
Accidental[0] = Accidental.Natural
Accidental[1] = Accidental.Sharp

export wrap := (array, index: number) ->
  array[mod index, array.length]

export mod := (n: number, k: number) ->
  (n % k + k) % k

###
Quantize a number, rounding it to the nearest nth unit.

    assert.equal quantize(61, 4), 60
    assert.equal quantize(63, 4), 64

    assert.equal quantize(0.77, 0.25), 0.75
    assert.equal quantize(0.55, 0.25), 0.5

If the unit is zero then return the number as is.

    assert.equal quantize(0.33333, 0), 0.33333

###
export quantize := (x: number, n: number) ->
  if n is 0
    return x

  ((x / n + 1/2)|0) * n

// Compare two notes, earlier times first, then lower notes
export noteCompare := ([ta, na], [tb, nb]) ->
  if ta < tb
    -1
  else if ta > tb
    1
  else
    if na < nb
      -1
    else if na > nb
      1
    else
      0

export composedPath := (el: HTMLElement) ->
  path := []

  while el
    path.push el

    if el.tagName is 'HTML'
      path.push document
      path.push window
      break

    el = el.parentElement

  return path

/**
a is accidental 0, +1, or -1
deprecated: this is the older style pitch where C4 is 0
*/
export staffNoteToPitch := (n: number, a=0, key=0) ->
  r := mod n, 7
  o := Math.floor(n/7)

  pitch := o * 12 + scale[key][r] + a

  return pitch


/**
These are MIDI pitches 0-127 where C4 is 60
midiPitch = staffNoteToMidiPitch(staffNote, accidental, keySignatureNumber)
*/
export staffNoteToMidiPitch := (n: number, a?: number, key?: number) ->
  staffNoteToPitch(n, a, key) + 60

export keySignatures := [[ // major
  "C♭"
  "G♭"
  "D♭"
  "A♭"
  "E♭"
  "B♭"
  "F"
  "C"
  "G"
  "D"
  "A"
  "E"
  "B"
  "F#"
  "C#"
], [ // minor
  "a♭"
  "e♭"
  "b♭"
  "f"
  "c"
  "g"
  "d"
  "a"
  "e"
  "b"
  "f#"
  "c#"
  "g#"
  "d#"
  "a#"
  ]
]

export bufferStartsWith := (buffer: Uint8Array, str: string) ->
  codes := Array.from(str).map (c) ->
    n := c.charCodeAt(0)
    if n > 255
      throw new Error "Character outside of ascii range"

    return n

  codes.reduce (result, c, i) ->
    result and buffer[i] is c
  , true

export accidentalToSymbol := (accidental: number) ->
  if accidental is 1
    "♯"
  else if accidental is -1
    "♭"
  else
    ""

/** Unique integer key per channel note */
export channelNoteKey := (c: number, n: number) ->
  (c << 7) + n

export exponentialRamp := (v0: number, v1: number, t0: number, t1: number, t: number) ->
  e := (t - t0) / (t1 - t0)

  v0 * pow(v1 / v0, e)

export emptyElement := (el: HTMLElement) ->
  while el.lastChild
    el.lastChild.remove()

export inRange := (range, [t, n]) ->
  [[t0, t1],[n0,n1]] := range

  t0 <= t <= t1 and n0 <= n <= n1

// Convert midi key signature to text
// m [-7 to 7], n [0, 1]
export midiKeySignatureName := (n: number, m=0) ->
  keySignatures[m][n + 7]

export eventToElementPosition := (e: MouseEvent, el: HTMLElement) ->
  {pageX, pageY} := e
  {top, left} := el.getBoundingClientRect()

  x: pageX - left
  y: pageY - top

export toHex := (n: number) ->
  n.toString(16).padStart(2, '0')

/**
Translate a number to a music note name.

1 is C#4
0 is C4
-1 is B3
...
 */
export noteName := (noteNumber: number) ->
  noteNumber |= 0

  note := wrap notes, noteNumber

  octave := (noteNumber / 12 - 1)|0

  `${note}${octave}`

export patternSampleNotes := (pattern, offset=0) ->
  pattern.notes().reduce (notes, [_, staffNote, accidental, instrument]) ->
    if notes.length < 4
      pitch := staffNoteToPitch staffNote+offset, accidental
      instrumentPitchExists := notes.some ([i, p]) ->
        i is instrument and p is pitch

      unless instrumentPitchExists
        notes.push [instrument, pitch]

    return notes
  , []

/**
midi note -> [staff position, accidental]
staff positions: C4 is 0
*/
export midiPitchToStaffNote := (n: number, s=0): [number, ValueOf<typeof Accidental>] ->
  n = n - 60

  r := mod n, 12
  o := floor n/12

  invScale := scaleInv[s]

  [staffNote, a] .= invScale[r]

  scaleAccidental := scaleAccidentals[s][staffNote]

  if a is 0
    a = Accidental.None
  else
    a = Accidental[a + scaleAccidental] // -1 flat, 0 natural, 1 sharp

  [o * 7 + staffNote, a]

/**
[staff position, semitones off the key's scale note] of a MIDI pitch in a key.
staffNoteToMidiPitch(position, offset, key) gives the pitch back.
*/
export midiPitchToStaffPlace := (n: number, key=0): [number, number] ->
  [staffNote] := midiPitchToStaffNote(n, key)
  [staffNote, n - staffNoteToMidiPitch(staffNote, 0, key)]

/** Returns [scale degree, accidental] */
export pitchToStaffNote := (n: number, s=0) ->
  r := mod n, 12
  o := floor n/12

  invScale := inverseScales[s]

  staffNote: number .= invScale[r]
  let a
  if staffNote?
    a = 0
  else
    if s < 0
      staffNote = invScale[r + 1]
      a = -1
    else
      staffNote = invScale[r - 1]
      a = 1

  [o * 7 + staffNote, a] as const

export function rand<T>(a: T[])
  a[floor random() * a.length]
